import { removeFromTombStone } from './moveSharedFolderItemsOrchestrator';
import showNotificationOnMove from '../actions/move/helpers/showNotificationOnMove';
import { updateCountForConversationMove } from '../actions/move/helpers/updateFolderCountForArchiveMailbox';
import moveSharedFolderConversations from '../actions/moveSharedFolderConversations';
import { exportedHelperFunctions as exportedDeleteFunctions } from '../actions/deleteConversations';
import deleteConversationStoreUpdate from 'owa-mail-actions/lib/triage/deleteConversationStoreUpdate';
import { showNotificationOnMoveFailure } from 'owa-mail-filterable-menu-behavior';
import reloadTable from 'owa-mail-triage-table-load-extra/lib/actions/reloadTable';
import { getMailboxInfo } from 'owa-mail-mailboxinfo';
import copyConversationService from '../services/copyConversationService';
import * as trace from 'owa-trace';
import { orchestrator } from 'satcheljs';
import {
    getApplyConversationActionContext,
    getRowIdsFromRowKeys,
    getContextFolderIdForTable,
} from 'owa-mail-list-store';

export default orchestrator(moveSharedFolderConversations, async actionMessage => {
    const { rowKeys, originalTableView, destinationFolderId } = actionMessage;

    const conversationActionContexts = rowKeys.map(rowKey =>
        getApplyConversationActionContext(rowKey, originalTableView.id)
    );
    const conversationIdStrings = getRowIdsFromRowKeys(rowKeys, originalTableView.id);

    // Update folder count manually for shared folder
    updateCountForConversationMove(rowKeys, originalTableView, destinationFolderId);
    deleteConversationStoreUpdate(conversationIdStrings, originalTableView, 'Move');

    try {
        // Make copy service request
        // Wait for copy request to make further delete service call
        const copyResponse = await copyConversationService(
            conversationActionContexts,
            destinationFolderId,
            originalTableView.tableQuery.folderId
        );
        if (copyResponse && copyResponse.ResponseClass == 'Success') {
            const mailboxInfo = getMailboxInfo(originalTableView);

            // Make delete service request only after success of copyItems api
            const deleteResponse = await exportedDeleteFunctions.invokeDeleteConversationMutation(
                conversationActionContexts,
                getContextFolderIdForTable(originalTableView),
                'HardDelete' /* disposalType */,
                mailboxInfo
            );

            /*
             * Items are removed from the Tombstone regardless of the api response and in the case failure table is also reloaded.
             * This is done to avoid infinite loading bug, which occurs if delete api fails for shared folder or
             * server notification falis for primary mailbox
             */
            removeFromTombStone(originalTableView, rowKeys);
            if (!deleteResponse.success) {
                reloadTable(originalTableView);

                // Show failure notification for the error if delete api fails
                showNotificationOnMoveFailure(destinationFolderId);
            } else {
                // Show move items notification for shared folder only after both the apis return with success
                showNotificationOnMove(
                    conversationActionContexts.length,
                    destinationFolderId,
                    false /* allowUndo */
                );
            }
        } else {
            /**
             * Items are removed from the Tombstone and table is reloaded if the copyItems service fails
             */
            removeFromTombStone(originalTableView, rowKeys);
            reloadTable(originalTableView);

            // Show failure notification for the error if copy api fails
            showNotificationOnMoveFailure(destinationFolderId);
        }
    } catch (error) {
        trace.errorThatWillCauseAlert(
            'Shared Folder move conversation action failed : ' + JSON.stringify(error)
        );
    }
});
